"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Tab_component_exports = {};
__export(Tab_component_exports, {
  Tab: () => Tab
});
module.exports = __toCommonJS(Tab_component_exports);
var import_react = __toESM(require("react"));
var import_useOnKeydown = require("../../../../utils/useOnKeydown/useOnKeydown.hook");
var import_atoms = require("../../../atoms");
var import_Badge = require("../../../atoms/Badge/Badge.component");
var import_Tab = require("./Tab.styled");
var import_TabListContext = require("../TabListContext");
var _excluded = ["isDisabled"];
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var Tab = /* @__PURE__ */ (0, import_react.forwardRef)(function(_ref, customTabRef) {
  var _props$title;
  var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, props = _objectWithoutProperties(_ref, _excluded);
  var _UseTabListContext = (0, import_TabListContext.UseTabListContext)(import_TabListContext.TabListContext, "Tab"), selectedTabId = _UseTabListContext.selectedTabId, handleOnSelect = _UseTabListContext.handleOnSelect;
  var tabRef = (0, import_react.useRef)(null);
  var selected = selectedTabId === props.id;
  var onClick = function onClick2() {
    if (handleOnSelect && !isDisabled) {
      handleOnSelect(props.id, props.title);
    }
  };
  (0, import_useOnKeydown.useOnKeydown)(customTabRef || tabRef, function(keyList) {
    if (keyList.Enter && !isDisabled) {
      handleOnSelect(props.id, props.title);
    }
  });
  return /* @__PURE__ */ import_react.default.createElement(import_Tab.StyledTab, {
    "data-testid": "".concat(props.id, "-test-tab"),
    "aria-selected": selected,
    "aria-controls": props.ariaControl || props.id,
    "aria-disabled": isDisabled,
    "aria-label": props.ariaLabel,
    id: props.id,
    role: "tab",
    onClick,
    ref: customTabRef || tabRef,
    isDisabled,
    selected,
    "data-dp-analytics-id": props.dataDpAnalyticsId,
    tabIndex: selected ? 0 : -1,
    fontSize: props.fontSize,
    isBold: props.isBold
  }, props.iconName && /* @__PURE__ */ import_react.default.createElement(import_atoms.Icon, {
    icon: props.iconName,
    size: 20
  }), /* @__PURE__ */ import_react.default.createElement(import_Tab.StyledContentContainer, null, /* @__PURE__ */ import_react.default.createElement("span", null, (_props$title = props.title) === null || _props$title === void 0 ? void 0 : _props$title.trim()), props.content && /* @__PURE__ */ import_react.default.createElement("span", null, props.content)), props.badgeLabel && /* @__PURE__ */ import_react.default.createElement(import_Tab.StyledBadge, {
    text: props.badgeLabel.trim(),
    badgeType: import_Badge.BadgeType.round,
    badgeColor: import_Badge.BadgeColor.pr
  }));
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Tab
});
//# sourceMappingURL=Tab.component.js.map